module.exports = __webpack_public_path__ + "34c49ac80d6e542015f604a8e8fd60f2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/vaneck.png
// module id = 1747
// module chunks = 0